var ModalToggle = /** @class */ (function () {
    function ModalToggle() {
        this.body = document.querySelector('body');
        this.modals = document.querySelectorAll('.modal');
        this.modalToggles = document.querySelectorAll('[data-toggle="modal"]');
        this.modalCloseToggles = document.querySelectorAll('[data-close-modal]');
        if (this.modals.length > 0 && this.modalCloseToggles.length > 0) {
            this.ifCookieModal();
            this.toggleModalURl();
            this.addEventListeners();
        }
    }
    ModalToggle.prototype.ifCookieModal = function () {
        var checkCookieModal = function (modal) {
            // check if is cookie modal
            if (modal.id.includes('cookie')) {
                // set cookie name
                var cookieName = 'lf-' + modal.id;
                // check if cookie exists
                if (document.cookie.includes(cookieName)) {
                    modal.remove(); // remove modal from dom
                }
                else {
                    // if cookie not exists - show modal & set cookie
                    modal.removeAttribute('aria-hidden');
                    document.cookie = "".concat(cookieName, "=true; max-age=").concat(60 * 60 * 24 * 180, "; path=/");
                }
            }
        };
        this.modals.forEach(checkCookieModal);
    };
    ModalToggle.prototype.toggleModalURl = function () {
        var hash = window.location.hash;
        if (hash && hash.includes('modal-')) {
            var modalId = hash.replace('#', '');
            var modal = document.getElementById(modalId);
            if (modal) {
                modal.classList.toggle('active');
                if (modal.classList.contains('active')) {
                    modal.removeAttribute('aria-hidden');
                }
                else {
                    modal.setAttribute('aria-hidden', 'true');
                }
            }
        }
    };
    ModalToggle.prototype.addEventListeners = function () {
        var _this = this;
        this.modalToggles.forEach(function (toggle) {
            toggle.addEventListener('click', _this.toggleModal.bind(_this));
        });
        this.modalCloseToggles.forEach(function (toggle) {
            toggle.addEventListener('click', _this.toggleModal.bind(_this));
        });
    };
    ModalToggle.prototype.toggleModal = function (toggle) {
        toggle.preventDefault();
        // get target from aria-controls attribute
        var targetModal = toggle.currentTarget.getAttribute('aria-controls');
        // if target is not found in aria-controls, get it from data-target attribute
        if (!targetModal) {
            targetModal = toggle.currentTarget.dataset.target;
        }
        // find element which id is equal to targetModal
        var modal = document.getElementById(targetModal);
        if (!modal) {
            // if no modal found - do nothing
            return;
        }
        modal.classList.toggle('active');
        if (modal.classList.contains('active')) {
            modal.removeAttribute('aria-hidden');
        }
        else {
            modal.setAttribute('aria-hidden', 'true');
        }
    };
    return ModalToggle;
}());
export default ModalToggle;
